import { Trees } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#040B11]/60 border-b border-emerald-900/30"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-link"
          className="flex items-center gap-2 group"
        >
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-emerald-900/40 border border-emerald-700/40 group-hover:border-amber-500/60 transition">
            <Trees className="w-5 h-5 text-amber-400" />
          </span>
          <span className="font-serif text-xl text-white tracking-wide">
            forestdays<span className="text-amber-400">.shop</span>
          </span>
        </a>
        <nav className="hidden sm:flex items-center gap-7 text-sm text-emerald-100/80">
          <button
            data-testid="nav-features"
            onClick={() => scrollTo("features")}
            className="hover:text-amber-400 transition"
          >
            Perks
          </button>
          <button
            data-testid="nav-how"
            onClick={() => scrollTo("how")}
            className="hover:text-amber-400 transition"
          >
            How it works
          </button>
          <button
            data-testid="nav-order"
            onClick={() => scrollTo("order")}
            className="px-4 py-2 rounded-full bg-amber-500/90 text-[#1a0e00] font-bold hover:bg-amber-400 transition ember-pulse"
          >
            Order — from $5
          </button>
        </nav>
      </div>
    </header>
  );
}
